<template>
  <div class="modern-dashboard-menu">
    <div class="container">
      <div class="modern-tiles-grid" v-if="tilesObj.length > 0">
        <transition-group
          name="tile-fade"
          tag="div"
          class="modern-grid-wrapper"
          :class="{ 'single-mode': single }"
        >
          <div
            v-for="(tile, i) in tilesObj"
            :key="tile.route + i"
            class="modern-tile-wrapper"
            :style="{ 'animation-delay': `${i * 0.1}s` }"
          >
            <div
              class="modern-tile-card"
              @click="goTo(tile.route)"
              :style="getTileStyle(i)"
            >
              <!-- Animated background gradient -->
              <div class="modern-tile-bg-gradient"></div>

              <!-- Content overlay -->
              <div class="modern-tile-content">
                <!-- Icon section -->
                <div class="modern-tile-icon-wrapper">
                  <div class="modern-icon-circle">
                    <i
                      v-if="tile.iClass"
                      :class="tile.iClass"
                      class="modern-tile-icon-fa"
                    ></i>
                    <v-icon v-else size="28" dark class="modern-tile-icon-v">
                      {{ tile.icon }}
                    </v-icon>
                  </div>
                </div>

                <!-- Title section -->
                <div class="modern-tile-title-wrapper">
                  <h3 class="modern-tile-title">
                    {{ tile.label || tile.title }}
                  </h3>
                  <div class="modern-tile-arrow">
                    <v-icon color="white" size="14">mdi-arrow-right</v-icon>
                  </div>
                </div>
              </div>

              <!-- Shimmer effect on hover -->
              <div class="modern-tile-shimmer"></div>
            </div>
          </div>
        </transition-group>
      </div>

      <!-- Empty state -->
      <div v-else class="modern-empty-state">
        <v-icon size="80" color="grey lighten-1"
          >mdi-view-dashboard-outline</v-icon
        >
        <p class="modern-empty-text">No tiles available</p>
      </div>
    </div>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";

export default {
  props: {
    tiles: {
      default: () => [],
    },
    currentUser: {
      default: null,
    },
    currentCompany: {
      default: null,
    },
    single: {
      default: false,
    },
  },
  watch: {
    tiles(newTiles) {
      this.filterTiles(newTiles);
    },
  },

  data: () => ({
    overlay: false,
    tilesObj: [],
    colors: [],
    gradients: [
      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
      "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      "linear-gradient(135deg, #30cfd0 0%, #330867 100%)",
      "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
      "linear-gradient(135deg, #ff9a56 0%, #ff6a88 100%)",
      "linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)",
      "linear-gradient(135deg, #f6d365 0%, #fda085 100%)",
      "linear-gradient(135deg, #96fbc4 0%, #f9f586 100%)",
      "linear-gradient(135deg, #8EC5FC 0%, #E0C3FC 100%)",
    ],
  }),
  mounted() {
    this.filterTiles(this.tiles);
    this.colors = helpersJs.getColors();
  },
  methods: {
    filterTiles(tiles) {
      let tilesArr = [];

      if (tiles.length > 0 && this.currentUser && this.currentUser.alevel) {
        tiles.forEach((tile) => {
          if (tile.alevel && typeof tile.alevel == "object") {
            if (tile.alevel.includes(Number(this.currentUser.alevel))) {
              tilesArr.push(tile);
            }
          } else if (tile.alevel && typeof tile.alevel == "number") {
            if (Number(this.currentUser.alevel) >= Number(tile.alevel)) {
              tilesArr.push(tile);
            }
          }
        });
      }

      if (tilesArr.length > 0 && this.currentCompany != null) {
        tilesArr = tilesArr.filter((tile) => {
          if (tile.industry && typeof tile.industry == "object") {
            return (
              tile.industry.includes(this.currentUser.industry) ||
              tile.industry.includes("All") ||
              tile.industry.includes("General")
            );
          } else if (tile.industry && typeof tile.industry == "string") {
            return (
              tile.industry == "All" ||
              tile.industry == "General" ||
              tile.industry == this.currentCompany.industry
            );
          }
        });
      }
      this.tilesObj = tilesArr;
    },
    getTileStyle(index) {
      const gradient = this.gradients[index % this.gradients.length];
      return {
        background: gradient,
      };
    },
    goTo(route) {
      this.$router.push(route);
    },
  },
};
</script>

<style scoped>
.modern-dashboard-menu {
  padding: 14px 0;
  min-height: 200px;
}

.modern-tiles-grid {
  width: 100%;
}

.modern-grid-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 18px;
}

.modern-grid-wrapper.single-mode {
  grid-template-columns: 1fr;
  max-width: 250px;
  margin: 0 auto;
}

@media (max-width: 960px) {
  .modern-grid-wrapper {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
  }
}

@media (max-width: 600px) {
  .modern-grid-wrapper {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

.modern-tile-wrapper {
  animation: tile-fade-in 0.6s ease-out backwards;
}

.modern-tile-card {
  position: relative;
  height: 180px;
  border-radius: 24px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.modern-tile-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
  transition: opacity 0.3s ease;
  z-index: 1;
}

.modern-tile-card:hover {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
}

.modern-tile-card:hover::before {
  opacity: 0;
}

.modern-tile-card:hover .modern-tile-bg-gradient {
  opacity: 1;
}

.modern-tile-card:hover .modern-tile-shimmer {
  animation: shimmer 1.5s infinite;
}

.modern-tile-card:hover .modern-tile-arrow {
  transform: translateX(8px);
}

.modern-tile-card:hover .modern-icon-circle {
  transform: scale(1.15) rotate(10deg);
}

.modern-tile-card:active {
  transform: translateY(-8px) scale(0.98);
}

.modern-tile-bg-gradient {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  opacity: 0;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.3) 0%,
    rgba(255, 255, 255, 0) 70%
  );
  transition: opacity 0.4s ease;
  pointer-events: none;
  z-index: 2;
}

.modern-tile-content {
  position: relative;
  height: 100%;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 3;
}

.modern-tile-icon-wrapper {
  display: flex;
  align-items: flex-start;
}

.modern-icon-circle {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.modern-tile-icon-fa {
  font-size: 42px;
  color: white;
}

.modern-tile-icon-v {
  color: white !important;
}

.modern-tile-title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.modern-tile-title {
  color: white;
  font-size: 22px;
  font-weight: 700;
  margin: 0;
  line-height: 1.3;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  flex: 1;
  letter-spacing: 0.3px;
}

.modern-tile-arrow {
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  flex-shrink: 0;
}

.modern-tile-shimmer {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.4) 50%,
    transparent 100%
  );
  z-index: 4;
  pointer-events: none;
}

/* Animations */
@keyframes tile-fade-in {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* Vue transition classes */
.tile-fade-enter-active {
  animation: tile-fade-in 0.6s ease-out backwards;
}

.tile-fade-leave-active {
  transition: all 0.3s ease;
}

.tile-fade-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

/* Empty state */
.modern-empty-state {
  text-align: center;
  padding: 80px 20px;
}

.modern-empty-text {
  margin-top: 16px;
  font-size: 18px;
  color: #9e9e9e;
  font-weight: 500;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .modern-tile-card {
    height: 180px;
  }

  .modern-icon-circle {
    width: 70px;
    height: 70px;
  }

  .modern-tile-icon-fa {
    font-size: 36px;
  }

  .modern-tile-title {
    font-size: 20px;
  }

  .modern-tile-content {
    padding: 24px;
  }
}

@media (max-width: 600px) {
  .modern-tile-card {
    height: 160px;
  }

  .modern-icon-circle {
    width: 60px;
    height: 60px;
  }

  .modern-tile-icon-fa {
    font-size: 32px;
  }

  .modern-tile-title {
    font-size: 18px;
  }

  .modern-tile-content {
    padding: 20px;
  }

  .modern-tile-arrow {
    width: 40px;
    height: 40px;
  }
}
</style>
